import { colors } from "../../theme/colors";
import { styled } from "@mui/material/styles";
import { Chip } from "@mui/material";

export const MgpChip = styled(Chip)(({ theme }) => ({}));
